import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import LinkButton from 'components/LinkButton';

import { MESSAGE_TYPE } from 'constants/message-types';
import { ROUTE } from 'constants/route';

const InboxAdditionalDataLink = props => {
  const { type } = props;

  const [url, text] = useMemo(() => {
    if (type === MESSAGE_TYPE.TYPE_CANDIDATE_NOTIFY_UPDATE_RESUME) {
      return [
        ROUTE.CANDIDATE_PROFILE + '?action=updateResume',
        'Update Resume',
      ];
    }

    if (type === MESSAGE_TYPE.TYPE_CANDIDATE_NOTIFY_GAT) {
      return [ROUTE.CANDIDATE_APTITUDE, 'Go to GoBuyside Aptitude Test'];
    }

    if (type === MESSAGE_TYPE.TYPE_CANDIDATE_NOTIFY_INTERVIEW_DATA) {
      return [
        ROUTE.CANDIDATE_PROFILE + '?action=updateInterviewData',
        'Lets get started',
      ];
    }
  }, [type]);

  return (
    <div style={{ marginTop: '6px' }}>
      <LinkButton btnFontWeight={400} to={url} text={text} />
    </div>
  );
};

InboxAdditionalDataLink.propTypes = {
  type: PropTypes.oneOf([
    MESSAGE_TYPE.TYPE_CANDIDATE_NOTIFY_UPDATE_RESUME,
    MESSAGE_TYPE.TYPE_CANDIDATE_NOTIFY_GAT,
    MESSAGE_TYPE.TYPE_CANDIDATE_NOTIFY_INTERVIEW_DATA,
  ]),
};

export default InboxAdditionalDataLink;
